import { useEffect, useRef } from "react";
import { useAuth } from "@/app/providers";
import { registerWebPush } from "./registerWebPush";
import { getVapidPublicKey, isWebPushSupported } from "./vapid";

/**
 * Synchronise l'abonnement push si la permission est déjà accordée.
 * La demande initiale passe par PushPermissionPrompt (geste utilisateur requis).
 */
export function useWebPushRegistration(): void {
  const { token, currentBuilding } = useAuth();
  const lastKeyRef = useRef<string | null>(null);

  const buildingId = currentBuilding?.pk ?? null;

  useEffect(() => {
    if (!token || buildingId == null) {
      lastKeyRef.current = null;
      return;
    }

    if (!isWebPushSupported() || !getVapidPublicKey()) {
      return;
    }

    if (Notification.permission !== "granted") {
      return;
    }

    const key = `${token}:${buildingId}`;
    if (lastKeyRef.current === key) {
      return;
    }
    lastKeyRef.current = key;

    void registerWebPush({
      token,
      buildingId,
      client: "accueilv2",
      requestPermission: false,
    });
  }, [token, buildingId]);
}
